"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MusicInfoBlock_1 = __importDefault(require("./MusicInfoBlock"));
const SheetBlock_1 = __importDefault(require("./SheetBlock"));
const PageNavigator_1 = __importDefault(require("./PageNavigator"));
const DataStorageManager_1 = __importDefault(require("../../data/DataStorageManager"));
class SheetPageManager {
    constructor(container) {
        this.container = container;
    }
    init() {
        this.renderSheetPage();
        this.setupPageNavigation();
    }
    renderSheetPage() {
        const sheetPageContainer = document.createElement('div');
        sheetPageContainer.classList.add('sheet-page-container');
        this.musicInfoBlock = new MusicInfoBlock_1.default();
        // there (?) means pages & 's ID
        this.sheetBlock_1 = new SheetBlock_1.default(1);
        this.sheetBlock_2 = new SheetBlock_1.default(2);
        this.sheetBlock_3 = new SheetBlock_1.default(3);
        // default Setting
        sheetPageContainer.appendChild(this.musicInfoBlock.getElement());
        sheetPageContainer.appendChild(this.sheetBlock_1.getElement());
        this.container.appendChild(sheetPageContainer);
    }
    setupPageNavigation() {
        new PageNavigator_1.default(this.container, 3, (pageNum) => this.switchPage(pageNum));
    }
    switchPage(pageNum) {
        // *1* Save Data to Array
        DataStorageManager_1.default.collectDataFromDOM();
        // *2* Select currentblock & Remove then add New .
        const sheetPageContainer = this.container.querySelector('.sheet-page-container');
        if (sheetPageContainer) {
            const existingSheetBlock = sheetPageContainer.querySelector('.sheet-block');
            if (existingSheetBlock) {
                existingSheetBlock.remove();
            }
            const sheetBlock = this[`sheetBlock_${pageNum}`];
            if (sheetBlock) {
                sheetPageContainer.appendChild(sheetBlock.getElement());
            }
        }
        // Apply Data to Dom
        DataStorageManager_1.default.applyDataToDOM();
    }
}
exports.default = SheetPageManager;
// ^^^^^^^^^ check! 2024/11/19 ^^^^^^^^
